import {
  backendFetch,
  type BackendRequestInit,
} from "@softmax/observatory-client/transport";
import type { FlagsResponse } from "@softmax/observatory-client/types";
import { flagIsOn, type ObservatoryFlagKey } from "@softmax/web-features/flags";

export async function flagOn({
  key,
  signal,
}: {
  key: ObservatoryFlagKey;
  signal?: AbortSignal | undefined;
}): Promise<boolean> {
  const options: BackendRequestInit = {};

  if (signal !== undefined) options.signal = signal;

  const response = await backendFetch<FlagsResponse>(
    "",
    "/api/site-flags",
    options,
  );
  return flagIsOn({ flags: response.flags, key });
}

export function roomFlagState({
  key,
  signal,
}: {
  key: ObservatoryFlagKey;
  signal?: AbortSignal | undefined;
}): Promise<"enabled" | "disabled" | "unavailable"> {
  return flagOn({ key, signal }).then(
    (enabled) => (enabled ? "enabled" : "disabled"),
    () => {
      signal?.throwIfAborted();
      return "unavailable";
    },
  );
}
